import styled from 'styled-components';

import { mobile } from './utils/breakpoints';

export const ShowOnMobile = styled.div`
  @media only screen and (min-width: calc(${mobile} + 1px)) {
    display: none;
  }
`;
